import React from "react";
import { 
  Box, 
  useTheme 
} from "@mui/material";
import BreadCrumb from "../../Atom/Breadcrumbs/Breadcrumb";
import ChooseIndustry from "../ChooseIndustry/ChooseIndustry";
import { createFlexStyles } from '../../../theme/layoutStyles';

/**
 * Design component for the design page
 * Material UI version
 */
export const Design: React.FC = () => {
  const theme = useTheme();
  const flexStyles = createFlexStyles(theme);

  // Styles following Material UI patterns
  const styles = {
    container: {
      ...flexStyles.flexColumn,
      height: '100vh',
      width: '100%'
    },
    contentContainer: {
      ...flexStyles.flexColumn,
      justifyContent: 'space-between',
      padding: theme.spacing(3.75), // 30px equivalent
      flex: 1
    },
    titleSection: {
      ...flexStyles.flexCenterBetween,
      alignItems: 'flex-start', // Override center alignment
      marginBottom: theme.spacing(3),
      width: '100%'
    },
    titleContent: flexStyles.flexColumn,
    stepTitle: {
      color: theme.palette.primary.main,
      fontSize: '2rem', // 32px equivalent
      fontWeight: 'normal',
      margin: 0,
    },
    chooseTitle: {
      ...flexStyles.flexCenterGap1,
      fontSize: '1.5rem', // 24px equivalent
      fontWeight: 'normal',
      color: theme.palette.text.primary,
      margin: 0,
      paddingTop: theme.spacing(1.25) // 10px equivalent
    },
    industrySection: {
      ...flexStyles.flexColumn,
      flex: 1
    },
    buttonContainer: {
      ...flexStyles.flexCenter,
      justifyContent: 'center', // Explicit center for both axes
      paddingTop: theme.spacing(2)
    },
    previousButton: {
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.divider}`,
      color: theme.palette.text.primary,
      padding: theme.spacing(1, 3),
      textTransform: 'none',
      borderRadius: theme.shape.borderRadius,
      alignSelf: 'flex-start',
      '&:hover': {
        backgroundColor: theme.palette.grey[50],
        borderColor: theme.palette.primary.main,
      },
    },
  };

  return (
    <Box sx={styles.container}>
      <BreadCrumb />
      
      <Box sx={styles.contentContainer}>
        {/* Main Content */}
        <Box sx={styles.industrySection}>
          {/* Industry Selection Component */}
          <ChooseIndustry />
        </Box>
      </Box>
    </Box>
  );
};

export default Design; 